import { Box, Stack, Typography } from "@mui/material";

export function TableToolbar({ title, count, children }) {
  return (
    <Box
      sx={{
        display: "flex",
        minHeight: 48,
        px: 0.9,
        py: 0.6,
        alignItems: { xs: "stretch", sm: "center" },
        justifyContent: "space-between",
        flexDirection: { xs: "column", sm: "row" },
        gap: 0.75,
      }}
    >
      <Stack direction="row" spacing={0.75} alignItems="center">
        <Typography component="h1" sx={{ fontSize: "0.875rem", fontWeight: 600 }}>
          {title}
        </Typography>
        {typeof count === "number" ? (
          <Box
            component="span"
            sx={{
              display: "inline-grid",
              minWidth: 24,
              height: 20,
              px: 0.5,
              color: "text.secondary",
              bgcolor: "#ECEEF1",
              fontSize: "0.75rem",
              fontWeight: 600,
              placeItems: "center",
            }}
          >
            {count}
          </Box>
        ) : null}
      </Stack>

      <Stack
        direction="row"
        spacing={0.75}
        useFlexGap
        sx={{
          minWidth: 0,
          flexWrap: "wrap",
          justifyContent: { xs: "flex-start", sm: "flex-end" },
        }}
      >
        {children}
      </Stack>
    </Box>
  );
}
